export default "__VITE_ASSET__sl7tryL2__"